import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getInsigniaListSuccess(insignia) {
  return {type: types.LOAD_INSIGNIA_LIST_SUCCESS, insignia};
}



export function getInsigniaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InsigniaApi.getInsigniaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(insignia => {                  
                  dispatch(getInsigniaListSuccess(insignia));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getInsigniaSuccess(catalogo) {
  return {type: types.LOAD_INSIGNIA_SUCCESS, catalogo};
}

export function getInsignia(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().InsigniaApi.getInsignia(id, token).then(insignia => {   
        dispatch(getInsigniaSuccess(insignia));
        return insignia;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(insignia) {
  return {type: types.SAVE_INSIGNIA_SUCCESS, insignia};
}


export function save(insignia, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().InsigniaApi.save(insignia, token).then(insigniaGuardado => {   
    dispatch(saveSuccess(insigniaGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getInsigniaComboSuccess(datos) {
  return {type: types.GET_INSIGNIAS_COMBO_SUCCESS, datos};
}

export function getInsigniaCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().InsigniaApi.getInsigniaCombo(token).then(datos => {   
        
      dispatch(getInsigniaComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(insignia) {
  return {type: types.BORRAR_INSIGNIA_SUCCESS, insignia};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InsigniaApi.borrar(id, token ).then(insignia => {
               
                  dispatch(borrarSuccess(insignia));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(insignia) {
  return {type: types.ACTIVAR_INSIGNIA_SUCCESS, insignia};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().InsigniaApi.activar(id, token).then(insignia => {
               
                  dispatch(activarSuccess(insignia));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_INSIGNIA, filtro};
}



